export default __webpack_public_path__ + "static/media/how-people-tablet.8cf988d5.jpg";